import { useMemo } from 'react';
import { Box, GridItem } from '@chakra-ui/react';
import { FaFlag } from 'react-icons/fa';
import moment from 'moment';

import CRUD, {
  useCRUD,
  Editor,
  Table,
  FilterInputSearch,
  Filters,
  BtnRefresh,
  BtnInactive,
  BtnAddRecord,
  InactiveFlag,
} from 'Library/CRUD';
import { useDB } from 'store';
import { Alert } from 'components';
import { useAlert } from 'utils';

import { ScheduleEdit } from './ScheduleEdit';

export const Schedule = () => {
  const [alert, setAlert] = useAlert();

  // eslint-disable-next-line
  const crud = useCRUD({
    id: 'schedule',
    title: 'Schedule',
    hasEditor: true,
    keyField: 'id',
    setAlert: setAlert,
    editor: {
      title: 'Schedule',
    },
    fetch: async () => {
      const result = await useDB.getState().axios({
        server: 'PAYGATE',
        method: 'GET',
        url: `/api/management/schedule/fetch`,
      });
      return result.data;
    },
    create: async (rec: any) => {
      const result = await useDB.getState().axios({
        server: 'PAYGATE',
        method: 'POST',
        url: `/api/management/schedule/create`,
        data: rec,
      });
      return result;
    },
    read: async (key: string) => {
      const result = await useDB.getState().axios({
        server: 'PAYGATE',
        method: 'GET',
        url: `/api/management/schedule/read/${key}`,
      });
      return result;
    },
    update: async (rec: any) => {
      const result = await useDB.getState().axios({
        server: 'PAYGATE',
        method: 'POST',
        url: `/api/management/schedule/create`,
        data: rec,
      });
      return result;
    },
    delete: async (key: string) => {
      const result = await useDB.getState().axios({
        server: 'PAYGATE',
        method: 'DELETE',
        url: `/api/management/schedule/delete/${key}`,
      });
      return result;
    },
  });

  let columns = useMemo(
    () => [
      {
        name: <FaFlag />,
        selector: (row: any) => row['inactive'],
        format: (row: any) => <InactiveFlag flag={row.inactive} />,
        width: '25px',
        omit: !crud.inactive,
      },
      {
        name: 'ID',
        selector: (row: any) => row['id'],
        sortable: true,
        width: '70px',
      },
      {
        name: 'Provider',
        selector: (row: any) => row['provider'],
        sortable: true,
        width: '120px',
      },
      {
        name: 'Task',
        selector: (row: any) => row['task'],
        sortable: true,
        width: '120px',
      },
      {
        name: 'Days',
        selector: (row: any) => row['days'],
        width: '80px',
      },
      {
        name: 'Hour',
        selector: (row: any) => row['hour'],
        width: '60px',
      },
      {
        name: 'Minute',
        selector: (row: any) => row['minute'],
        width: '60px',
      },
      {
        name: 'Last Run Time',
        selector: (row: any) => row['last_run_time'],
        format: (row: any) => moment(row.last_run_time).format('DD/MM/YYYY @ hh:mm a'),
        width: '160px',
      },
    ],
    [crud.inactive],
  );

  const filters = useMemo(() => {
    return (
      <Filters
        templateColumns={['1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr', '400px 1fr 150px 150px 150px']}
      >
        <FilterInputSearch crud={crud} />
        <GridItem />
        <BtnInactive crud={crud} />
        <BtnRefresh crud={crud} />
        <BtnAddRecord crud={crud} />
      </Filters>
    );
    // eslint-disable-next-line
  }, [crud.filter, crud.inactive]);

  return (
    <Box fontFamily={'Roboto Condensed'} h="100%">
      <CRUD id="merchants" crud={crud} filters={filters}>
        <Alert alert={alert} setAlert={setAlert} />
        <Editor crud={crud}>
          <ScheduleEdit id="merchant-edit" crud={crud} />
        </Editor>
        <Table
          id="merchant-table"
          crud={crud}
          columns={columns}
          responsive
          paginationContext={true}
        ></Table>
      </CRUD>
    </Box>
  );
};
